<template>
	<div class="logins">
		<div class="login-imgs">
			<img src="@/assets/img/login.png" alt="">
		</div>
		<div class="login-main">
			<h2>运营管理后台</h2>
			<div class="mainlists">
				<ul class="ullistarr">
					<li v-for="(item,index) in arryanzheng" :key="index" @click="xuande(index)">
						<span :class="xuan==index?'hengxian':'hengxians'">{{item.name}}</span>
					</li>
				</ul>
			</div>
			<div v-if="xuan==0">
				<div class="firstlogin">
					<el-input size="medium" @input="iptchanges" placeholder="请输入用户名" prefix-icon="el-icon-s-custom" v-model="username">
					</el-input>
				</div>
				<div class="firstlogin firstlogin1">
					<el-input size="medium" placeholder="请输入密码" show-password prefix-icon="el-icon-lock" @input="iptchangepass"
					 v-model="pass">
					</el-input>
				</div>
				<div class="threelogin">
					<div class="threelogin-left">
						<el-input size="medium" placeholder="请输入验证码" prefix-icon="el-icon-lock" v-model="num" @input="iptchangeyan">
						</el-input>
					</div>
					<div class="threelogin-right" @click="dianji">
						<img :src="urlimg" alt="">
					</div>
				</div>
				<p class="neirongcuoru">
					<span>{{texts}}</span>
				</p>
				<div class="firstlogin" @click="logins">
					<el-button type="primary">登录</el-button>
				</div>
			</div>
			<div v-if="xuan==1">
				<div class="firstlogin">
					<el-input size="medium" placeholder="请输入手机号码" prefix-icon="el-icon-s-custom" v-model="tel">
					</el-input>
				</div>
				<div class="threelogin">
					<div class="threelogin-left">
						<el-input size="medium" placeholder="请输入验证码" prefix-icon="el-icon-lock" v-model="code">
						</el-input>
					</div>
					<div class="threelogin-right threelogin-rights" @click="dianjit">
						{{sendtext}}
					</div>
				</div>
				<div class="firstlogin" @click="loginst">
					<el-button type="primary">登录</el-button>
				</div>
			</div>
		</div>
		<findepasss v-if="showmima" @sendmsg="senclones"></findepasss>
	</div>
</template>
<script>
	export default {
		components: {
			findepasss: resolve => {
				require(["./findpass.vue"], resolve);
			},
		},
		data() {
			return {
				imgUrl: this.$store.state.img_url,
				url: this.$store.state.p_url,
				urlimg: this.$store.state.p_url + 'crm/tool/captcha?num=' + Math.random([1, 10]),
				username: '',
				pass: '',
				num: '',
				imgss: '',
				texts: '',
				tel: '',
				code: '',
				showmima: false,
				arryanzheng: [{
					name: '账号密码登录',
					type: 1
				}, {
					name: '短信验证码登录',
					type: 2
				}],
				xuan: 0,
				sendtext: '获取验证码',
				timer: '',

			}
		},
		methods: {
			dianji() {
				this.urlimg = this.$store.state.p_url + 'crm/tool/captcha?num=' + Math.random([1, 10])
			},
			logins() {
				let that = this
				if (that.username != '') {
					if (that.pass != '') {
						if (that.num != '') {
							that.$axios.post(that.url + "crm/account/login", {
								username: that.username,
								password: that.pass,
								captcha: that.num
							}).then(res => {
								if (res.data.code == 200 || res.data.code == '200') {
									window.sessionStorage.setItem('name', res.data.data.name)
									window.sessionStorage.setItem('admincrm', res.data.data.admin)
									window.sessionStorage.setItem('appid', res.data.data.appid)
									window.sessionStorage.setItem('id', res.data.data.id)
									this.$axios.defaults.headers.common['admin'] = res.data.data.admin;
									this.$axios.defaults.headers.common['appid'] = res.data.data.appid;
									this.$router.push({
										path: '/overview',
									})
								} else {
									this.texts = res.data.msg
									this.dianji()
								}
								
							}).catch(function(err) {
								this.dianji()
							})
						} else {
							this.texts = '请输入您的验证码'
						}
					} else {
						this.texts = '请输入您的密码'
					}
				} else {
					this.texts = '请输入您的用户名'
				}
			},
			iptchanges(value) {
				if (value != '') {
					this.texts = ''
				}
			},
			iptchangepass(value) {
				if (value != '') {
					this.texts = ''
				}
			},
			iptchangeyan(value) {
				if (value != '') {
					this.texts = ''
				}
			},
			zhaohui() {
				this.showmima = true
			},
			senclones() {
				this.showmima = false
			},
			xuande(index) {
				this.xuan = index
			},
			dianjit() {
				let that = this
				if (that.tel == '') {
					this.$message({
						type: 'info',
						message: '请输入手机号码'
					});
					return
				}
				let data = {
					tel: that.tel
				}
				that.$axios.post(that.url + "crm/account/sendSms", data).then(res => {
					if (Number(res.data.code) == 200) {
						let data = 60
						that.timer = setInterval(function() {
							data--
							that.sendtext = data + 's后重试'
							if (data == 0) {
								clearTimeout(that.timer)
								that.sendtext = '获取验证码'
							}
						}, 1000)
					}
					this.$message({
						type: 'info',
						message: res.data.msg
					});
				})
			},
			loginst() {
				let that = this
				if (that.tel == '') {
					this.$message({
						type: 'info',
						message: '请输入手机号码'
					});
					return
				}
				if (that.code == '') {
					this.$message({
						type: 'info',
						message: '请输入验证码'
					});
					return
				}
				let data = {
					tel: that.tel,
					code: that.code
				}
				that.$axios.post(that.url + "crm/account/smsLogin", data).then(res => {
					if (Number(res.data.code) == 200) {
						window.sessionStorage.setItem('name', res.data.data.name)
						window.sessionStorage.setItem('admincrm', res.data.data.admin)
						window.sessionStorage.setItem('appid', res.data.data.appid)
						window.sessionStorage.setItem('id', res.data.data.id)
						this.$axios.defaults.headers.common['admin'] = res.data.data.admin;
						this.$axios.defaults.headers.common['appid'] = res.data.data.appid;
						this.$router.push({
							path: '/overview',
						})
					}
					this.$message({
						type: 'info',
						message: res.data.msg
					})
				})
			},

		},
		mounted() {
			$('title').html('登录')
		},
		destroyed(){
			 clearTimeout(this.timer)
		},

	}
</script>
<style scoped>
	.logins {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		position: relative;
	}

	.login-imgs img {
		position: absolute;
		left: 0;
		top: 0;
		width: 100vw;
		height: 100vh;
		display: block;
	}

	.login-main {
		width: 364px;
		min-height: 413px;
		background-color: #429ADA;
		position: absolute;
		left: 40%;
		top: 250px;
		right: 50%;
		border-radius: 4px;
		cursor: pointer;
		padding-bottom: 45px;
	}

	.login-main h2 {
		width: 364px;
		height: 92px;
		font-size: 20px;
		font-weight: bold;
		color: #ffffff;
		z-index: 5;
		display: flex;
		justify-content: center;
		align-content: center;
		line-height: 92px;
		letter-spacing: 3px
	}

	.firstlogin {
		width: 312px;
		height: 50px;
		margin: 0 auto;
		font-size: 14px;
	}

	>>>.el-input--medium .el-input__inner {
		height: 50px !important;
		line-height: 50px !important;
	}

	.firstlogin1 {
		margin-top: 20px
	}

	.firstlogin button {
		width: 312px;
		height: 50px;
		margin-top: 20px;
	}

	.threelogin {
		width: 312px;
		height: 50px;
		margin: 0 auto;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
	}

	.threelogin-left {
		width: 189px;
		height: 50px;
	}

	.threelogin-right {
		width: 117px;
		height: 50px;
		background-color: #ffffff;
	}

	.threelogin-rights {
		border-radius: 4px;
		background-color: #0080FF;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
	}

	.threelogin-right img {
		width: 117px;
		height: 50px;
		display: block;
		border-radius: 4px;
	}

	.ptext {
		width: 394px;
		position: absolute;
		bottom: 32px;
		font-size: 14px;
		color: #ffffff;
		left: 40%;
	}

	.neirongcuoru {
		width: 312px;
		height: 20px;
		text-align: center;
		line-height: 40px;
		font-size: 12px;
		color: #f00;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}

	.neirongcuoru span:nth-of-type(2) {
		width: 100px;
		height: 40px;
		display: block;
		text-align: right;
	}

	.mainlists {
		width: 100%;
		height: 40px;
		margin-bottom: 10px;
		color: #fff;
	}

	.ullistarr {
		display: flex;
		align-items: center;
		font-weight: 500;
	}

	.ullistarr li {
		width: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.hengxian {
		width: 70%;
		display: flex;
		height: 30px;
		align-items: flex-start;
		justify-content: center;
		border-bottom: 2px solid #fff;
	}

	.hengxians {
		width: 70%;
		display: flex;
		height: 30px;
		align-items: flex-start;
		justify-content: center;
		border-bottom: 2px solid #429ADA;
	}
</style>



// WEBPACK FOOTER //
// src/components/comment/login.vue